import React from 'react';
import '../../styles/components/AsientoLineasEditor.css';

export const formatNumber = (value) => {
    const numericValue = value.replace(/\./g, '').replace(/\D/g, '');
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const entriesToPayload = (entries) => entries.map((e) => ({
    cuenta: e.cuenta,
    monto: e.monto ? parseFloat(e.monto.toString().replace(/\./g, '')) : 0,
}));

export const sumaMontos = (entries) => entries.reduce((acc, e) => {
    const monto = e.monto ? parseFloat(e.monto.toString().replace(/\./g, '')) : 0;
    return acc + monto;
}, 0);

// Líneas Debe/Haber reutilizadas por AsientosForm (crear) y el modal de edición
// en la página de listado de asientos.
const AsientoLineasEditor = ({ cuentas, debeEntries, haberEntries, onDebeEntriesChange, onHaberEntriesChange }) => {
    const handleLineChange = (entries, onChange, index, field, value) => {
        const updated = [...entries];
        updated[index] = { ...updated[index], [field]: field === 'monto' ? formatNumber(value) : value };
        onChange(updated);
    };

    const addEntry = (entries, onChange) => {
        onChange([...entries, { cuenta: '', monto: '' }]);
    };

    const removeEntry = (entries, onChange, index) => {
        if (entries.length <= 1) return;
        onChange(entries.filter((_, i) => i !== index));
    };

    const renderColumna = (titulo, entries, onChange, placeholder) => (
        <div className="asiento-lineas-col">
            <h4>{titulo}</h4>
            {entries.map((entry, idx) => (
                <div key={`${placeholder}-${idx}`} className="asiento-linea-row">
                    <select
                        value={entry.cuenta}
                        onChange={(e) => handleLineChange(entries, onChange, idx, 'cuenta', e.target.value)}
                        required
                    >
                        <option value="">Cuenta {placeholder}</option>
                        {cuentas.map((c) => (
                            <option key={c.nombre_cuenta} value={c.nombre_cuenta}>{c.nombre_cuenta}</option>
                        ))}
                    </select>
                    <input
                        type="text"
                        value={entry.monto}
                        onChange={(e) => handleLineChange(entries, onChange, idx, 'monto', e.target.value)}
                        placeholder={placeholder}
                        required
                    />
                    {entries.length > 1 && (
                        <button
                            type="button"
                            className="asiento-linea-quitar"
                            onClick={() => removeEntry(entries, onChange, idx)}
                            aria-label={`Quitar línea de ${placeholder}`}
                        >
                            ×
                        </button>
                    )}
                </div>
            ))}
            <button type="button" onClick={() => addEntry(entries, onChange)}>Añadir {placeholder}</button>
        </div>
    );

    return (
        <div className="asiento-lineas-editor">
            {renderColumna('Debe', debeEntries, onDebeEntriesChange, 'Debe')}
            {renderColumna('Haber', haberEntries, onHaberEntriesChange, 'Haber')}
        </div>
    );
};

export default AsientoLineasEditor;
